import React from 'react';
import './header-card.scss';
import { View, Text } from '../../common';

interface HeaderCardProps {
  title: string;
  subtitle: string;
}

export const HeaderCard: React.FC<HeaderCardProps> = ({ title, subtitle }) => {
  return (
    <View>
      <Text className="header font-semibold">{title}</Text>
      <Text className="sub-header font-regular">{subtitle}</Text>
    </View>
  );
};
